/*******************************************************************************
GET TAB SETTINGS
Gather all the settings related to a tab.
*******************************************************************************/

export default function getTabSettings(tabName) {

    const $tab = $(`.filter-tab[data-name="${tabName}"]`);

    // The data to match against
    let dataToMatch = $tab.data('match').toString() || '';
    
    // On an individual tab, you can optionally add a secondary filter along with the data to match against
    const secSubset = $tab.data('secondary-subset') || '';
    let secDataToMatch = $tab.data('ss-match') || '';

    // By default, both the main filter AND the secondary filter have to match for an item to match
    // If this is set to OR, then it would only have to match one or the other
    const secSubsetOperator = ($tab.data('ss-operator') || 'AND').toUpperCase();

    // Check if we want to include matching items or exclude them
    const mainExclude = (dataToMatch.charAt(0) === '!');
    const secExclude = (secDataToMatch.charAt(0) === '!');

    // Strip off the ! character at the beginning of the match data (if it exists)
    dataToMatch = (mainExclude) ? dataToMatch.slice(1) : dataToMatch;
    secDataToMatch = (secExclude) ? secDataToMatch.slice(1) : secDataToMatch;

    // Convert the match criteria to an array (if it's not already)
    dataToMatch = (dataToMatch.includes(',')) ? dataToMatch.split(',') : [dataToMatch];
    secDataToMatch = (secDataToMatch.includes(',')) ? secDataToMatch.split(',') : [secDataToMatch];

    // Trim all the values in the arrays
    dataToMatch = $.map(dataToMatch, $.trim);
    secDataToMatch = $.map(secDataToMatch, $.trim);

    // Get the title text associated with the tab.
    // This is used in combination with the "title-target" data attribute on the set of tabs.
    const tabTitle = $tab.data('title') || '';

    /* The matchType options below control how the filtering works. There are two options:
    --------------------------------------------------------------------------
    1. exact - [default] The data has to exactly match the value. Examples:
        Looking for "1B" and value is "1B", then it would match
        Looking for "1B" and value is "1B/2B", it would NOT match
    2. contains - If this option is used, the data just needs to be somewhere in the value. Examples:
        Looking for "1B" and value is "1B", then it would match
        Looking for "1B" and value is "1B/2B", it would match
    ----------------------------------------------------------------------------*/
    const matchType = $tab.data('match-type') || 'exact';
    const secMatchType = $tab.data('ss-match-type') || 'exact';

    return {
        dataToMatch,       // The data that the main filter should try to match against
        mainExclude,       // Should the main filter match using the !== operator?
        matchType,         // Determines how the filtering works. Does the value have to exactly match or just appear within?
        secSubset,         // A secondary filter (in the form of a selector) just for this tab
        secDataToMatch,    // The data that the secondary filter should try to match against
        secExclude,        // Should the secondary filter match using the !== operator?
        secSubsetOperator, // [AND/OR] Do the main AND secondary filters have to match or just one OR the other?
        secMatchType,      // Determines how the filtering works. Does the value have to exactly match or just appear within?
        tabTitle,          // The title text that appears when this tab is selected.
    };
}
